import 'extensions/checkout/checkout.scss';
import './PROFORMA_OCST.scss';
import {PageManager} from 'genesis-packages/core';
import Checkout from 'extensions/checkout/Checkout.js';
import ExitTrigger from '@mvps-genesis/exit-trigger';
import HTMLFormValidatorScrollTop from 'extensions/form-validation/HTMLFormValidatorScrollTop';

export default class OCST extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	// eslint-disable-next-line max-lines-per-function
	onReady () {
		let redirectUrl = this.pageContext.Basket_Url;
		if (this.pageContext.ProForma_Modify_Quote && this.pageContext.ProForma_QuoteCode) {
			redirectUrl = `${this.pageContext.Quote_Url}QuoteCode=${this.pageContext.ProForma_QuoteCode}`;
		}

		new ExitTrigger('.js-exit-trigger', {
			message: 'Are you sure you want to exit checkout?',
			redirectUrl: redirectUrl
		});

		new Checkout();

		const ocstForm = document.getElementById('ocst-form');
		if (ocstForm) {
			this.resetButtons(ocstForm);
			ocstForm.addEventListener('submit', () => this.handleSubmit(ocstForm));

			ocstForm.HTMLFormValidator = new HTMLFormValidatorScrollTop({
				formElement: ocstForm,
				wrapperSelector: '.c-form-list__item'
			});
		}

		this.handleFieldDisplay();
	}

	handleSubmit (form) {
		const buttons = form.querySelectorAll('[type="submit"]');
		const loadingText = 'Loading...';

		if (buttons) {
			for (const button of buttons) {
				button.disabled = true;

				if (button.nodeName === 'INPUT') {
					button.setAttribute('data-original-text', button.value);
					button.value = loadingText;
				} else {
					button.setAttribute('data-original-text', button.innerText);
					button.innerText = loadingText;
				}
			}
		}
	}

	resetButtons (form) {
		const buttons = form.querySelectorAll('[type="submit"]');
		if (buttons) {
			for (const button of buttons) {
				const originalText = button.getAttribute('data-original-text');
				button.disabled = false;

				if (!originalText) {
					continue;
				}

				if (button.nodeName === 'INPUT') {
					button.value = originalText;
				} else {
					button.innerText = originalText;
				}
			}
		}
	}

	handleFieldDisplay () {
		const form = document.getElementById('proforma_form_fields');
		const trigger = document.getElementById('js-new-address-shipping');
		const icon = document.getElementById('js-address-icon');

		if (!form || !trigger || !icon) {
			return;
		}

		trigger.addEventListener('click', function () {
			form.classList.toggle('u-hidden');
			if (form.classList.contains('u-hidden')) {
				icon.classList.remove('u-icon-chevron-up');
				icon.classList.add('u-icon-chevron-down');
			} else {
				icon.classList.remove('u-icon-chevron-down');
				icon.classList.add('u-icon-chevron-up');
			}
		});
	}

};
